import type { FormatterProps } from '../types';
import React from 'react';

const ValueFormatter =  React.memo(function ValueFormatter<R, SR>(props: FormatterProps<R, SR>) {
  try {
    return <>{props.row[props.column.key as keyof R]}</>;
  } catch (e) {
    return null;
  }
}, (prevProps, nextProps) => prevProps.row === nextProps.row && prevProps.column === nextProps.column);

export { ValueFormatter }
